import React from 'react';
import './separator.css';
const Separator = () => {
	return <div className="separator" />;
};

export default Separator;
